import { useAttrs, computed } from 'vue-demi';

const useValidationAttributes = () => {
  const attributes = useAttrs();
  return {
    required: computed(() => attributes['required']),
    minlength: computed(() => attributes['minlength']),
    maxlength: computed(() => attributes['maxlength']),
    pattern: computed(() => attributes['pattern']),
    min: computed(() => attributes['min']),
    max: computed(() => attributes['max']),
    step: computed(() => attributes['step'])
  };
};

export { useValidationAttributes as u };
